import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";

interface Props {
  modelValue?: boolean;
  disabled?: boolean;
  loading?: boolean;
  size?: "default" | "small" | "middle" | "large";
  checkedChildren?: string;
  unCheckedChildren?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Switch',
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    size: { default: "default" },
    checkedChildren: { default: "" },
    unCheckedChildren: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onChange = (checked: boolean) => {
  emit("update:modelValue", checked);
  emit("change", checked);
};

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createBlock(_component_a_switch, {
    checked: innerValue.value,
    "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    disabled: _ctx.disabled,
    size: _ctx.size === 'small' ? 'small' : 'default',
    loading: _ctx.loading,
    "checked-children": _ctx.checkedChildren,
    "un-checked-children": _ctx.unCheckedChildren,
    onChange: onChange
  }, null, 8, ["checked", "disabled", "size", "loading", "checked-children", "un-checked-children"]))
}
}

})